import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, patch, post, put } from "helpers/api_helper"

export const fetchRoles = createAsyncThunk("admin/roles/all", async payload => {
  const response = await post("admin/roles/all", payload)
  return response
})

export const updateRoleStatus = createAsyncThunk(
  "admin/roles/details/update-status",
  async payload => {
    const response = await patch("admin/roles/details/update-status", payload)
    return response
  }
)

export const addNewRole = createAsyncThunk("admin/roles/add", async payload => {
  const response = await post("admin/roles/add", payload)
  return response
})

export const getRoleDetails = createAsyncThunk(
  "admin/roles/details",
  async payload => {
    const response = await post("admin/roles/details", payload)
    return response
  }
)

export const updateRoleDetails = createAsyncThunk(
  "admin/roles/details/update",
  async payload => {
    const response = await put("admin/roles/details/update", payload)
    return response
  }
)

export const deleteRole = createAsyncThunk(
  "admin/roles/delete",
  async payload => {
    const response = await del("admin/roles/delete", payload)
    return response
  }
)
